import { type App } from 'vue'
import { captureError } from '../utils/sentry'
import { useGlobalError } from '../hooks/useGlobalError'

/**
 * Vue错误处理插件
 */
export default {
  install(app: App) {
    let globalErrorHelper: ReturnType<typeof useGlobalError>

    // 延迟获取hook实例，确保在应用启动后获取
    const getGlobalErrorHelper = () => {
      if (!globalErrorHelper) {
        try {
          globalErrorHelper = useGlobalError()
        } catch (e) {
          console.warn('GlobalError hook not available yet')
        }
      }
      return globalErrorHelper
    }

    // 捕获Vue组件错误
    app.config.errorHandler = (error: unknown, instance, info) => {
      console.error('Vue Error:', error)

      const errorObj = error instanceof Error ? error : new Error(String(error))

      captureError(errorObj, {
        vueComponent: instance?.$options.name || 'Unknown',
        errorInfo: info,
        componentStack: instance?.$parent?.$options.name
      })

      const errorHelper = getGlobalErrorHelper()
      if (errorHelper) {
        errorHelper.showGlobalError('页面发生错误', errorObj.message)
      }
    }
  }
}
